@if (headerTemplate(); as header) {
  <div class="header">
    <ng-container [ngTemplateOutlet]="header" />
  </div>
} @else if (title()) {
  <h2 class="title" data-test="tlm-options-sheet:title">{{ title() }}</h2>
}

@for (group of optionGroups(); track $index) {
  <div class="group">
    @for (option of group; track option.id) {
      <button
        type="button"
        class="option"
        [class.destructive]="option.destructive"
        [disabled]="option.disabled"
        [attr.data-test]="'tlm-options-sheet:option:' + option.id"
        (click)="select(option)"
      >
        <span class="label">{{ option.label }}</span>
        @if (iconTemplate(); as icon) {
          <ng-container
            [ngTemplateOutlet]="icon"
            [ngTemplateOutletContext]="{ $implicit: option }"
          />
        }
      </button>
    }
  </div>
}
